import { render } from "./WidgetSearch.vue?vue&type=template&id=b7ba1fee&scoped=true&ts=true"
import script from "./WidgetSearch.vue?vue&type=script&lang=ts"
export * from "./WidgetSearch.vue?vue&type=script&lang=ts"

import "./WidgetSearch.vue?vue&type=style&index=0&id=b7ba1fee&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ba1fee"]])

export default __exports__